/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Title_2Inputs */

const et_benefits_title_2 = /** @type {(inputs: Benefits_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasuta liiklus`)
};

const en_benefits_title_2 = /** @type {(inputs: Benefits_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free traffic`)
};

/**
* | output |
* | --- |
* | "Free traffic" |
*
* @param {Benefits_Title_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_title_2 = /** @type {((inputs?: Benefits_Title_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Title_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_title_2(inputs)
	return en_benefits_title_2(inputs)
});